import { defaultExportedChart, defineChart } from '..'

import { tooltip } from '@/composables/useChart/theme'
import type { Values } from '@/composables/useValues'

type Params = [Values]

/**
 * Create the world treemap chart options.
 */
export default defineChart<Params>(data => {
    if (!data.dimension || !data.data) return {}

    const { config } = useParams()

    const items = config.showRegions ? data.regionalSorted : data.sorted

    const { getColor, getName } = useCountries()

    return {
        tooltip: {},
        series: {
            universalTransition: {
                enabled: true
            },
            type: 'treemap',
            sort: false,
            tooltip: {
                formatter(params) {
                    return tooltip(
                        '',
                        params.name,
                        data.formatter(params.value as number)
                    )
                }
            },
            breadcrumb: {
                show: false
            },
            itemStyle: {
                borderColor: 'white',
                borderWidth: 1
            },
            data: items.map(item => ({
                name: config.showRegions ? item.iso : getName(item.iso),
                value: item[data.valueKey as keyof typeof item],
                iso: item.iso,
                groupId: item.iso,
                itemStyle: {
                    color: config.showRegions
                        ? (item as any).color
                        : getColor(item.iso)
                }
            }))
        },
        export: defaultExportedChart({
            series: {
                top: '10%',
                height: '75%'
            }
        })
    }
})
